<div class="px-8 py-8">
  <div class="text-lg mb-3">Document Details</div>
  <form [formGroup]="searchForm" class="grid grid-cols-4 gap-4 bg-fieldset mb-4 p-4 rounded" >
    <div class="flex flex-col" *ngIf="!isSupreme && !isCOA">
      <mat-label>{{receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA?'Appeal Category':'Case Category'}}</mat-label>
      <mat-form-field>
        <input
          matInput
          [value]="receivedCaseData()[0].caseCategory==='FI'?'First Instance' :'Appeal'"
          readonly
          [disabled]="true"
        />
      </mat-form-field>
    </div>
    
    <div class="flex flex-col">
      <mat-label>Court Division</mat-label>
      <mat-form-field>
        <input
          matInput
          [value]="isEditMode ? receivedCaseData()[0].courtUnitName : ''"
          readonly
          [disabled]="true"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-col" *ngIf="isSupreme || isCOA" >
      <mat-label>{{isSupreme?'Court Below':'Lower Court'}}</mat-label>
      <mat-form-field>
        <input
          matInput
          [value]="isEditMode ? receivedCaseData()[0].appealCourtName : ''"
          readonly
          [disabled]="true"
        />
      </mat-form-field>
    </div>
    
    <div class="flex flex-col">
      <mat-label>{{ receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA? 'Appeal Type' : 'Case Type' }}</mat-label>
      <mat-form-field>
        <input
          matInput
          [value]="isEditMode ? receivedCaseData()[0].ctpShortName : ''"
          readonly
          [disabled]="true"
        />
      </mat-form-field>
    </div>
    
    <div class="flex flex-col">
      <mat-label>Document Types</mat-label>
      <mat-form-field>
        <input
          matInput
          [value]="isEditMode ? receivedCaseData()[0].docTypename : ''"
          readonly
          [disabled]="true"
        />
      </mat-form-field>
    </div>
      </form>
  

  <div class="form-container">
  <form *ngIf="showCaseStage" [formGroup]="searchForm2" class="px-4 btn-icon-section bg-fieldset"
  >
  <div class="flex">
    <div class="col-8 ">
  <div class="flex flex-wrap " *ngIf="data.data[0].caseCategory!='FI'">
    <div class="col-7" *ngIf="data.data[0].caseCategory!='FI'&& !isSupreme && !isCOA">
      <label class="required-label" >Lower Court</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [value]="data.data[0].appealCourtName" required placeholder="" readonly [disabled]="true" [tabindex]="null" />
      </mat-form-field>
      </div>
    </div>
    <div class="col-7" *ngIf="data.data[0].caseCategory!=='FI'&& (isSupreme ||isCOA)">
      <label class="required-label" >Appeal Stage</label>
      <div class="flex">  
      <mat-form-field appearance="outline" class="full-width" >
        <input matInput   readonly [value]="data.data[0].cptShortName" [disabled]="true" [tabindex]="null"/>
      </mat-form-field>
      </div>
    </div>
    <div class="col-1"  *ngIf="data.data[0].caseCategory!='FI'&& !isSupreme && !isCOA"></div>
    <div class="col-4" *ngIf="data.data[0].caseCategory!=='FI'&& !isSupreme && !isCOA">
      <label class="required-label" >Appeal Stage</label>
      <div class="flex">  
      <mat-form-field appearance="outline" class="full-width" >
        <input matInput   readonly [value]="data.data[0].cptShortName" [disabled]="true" [tabindex]="null"/>
      </mat-form-field>
      </div>
    </div>
    <div class="col-1" *ngIf="data.data[0].caseCategory!=='FI'" ></div>
    <div class="col-4" *ngIf="data.data[0].caseCategory!=='FI'&& (isSupreme||isCOA)">
      <label class="required-label" >Filed On</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width" >
        <input matInput  readonly [value]="data.data[0].dateReceived" [disabled]="true" [tabindex]="null" />
      </mat-form-field>
      </div>
      
    </div>
    
  </div>
  
  <div class="flex flex-wrap ">
    <div class="col-7">
      <label class="required-label">{{receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA ? '*Filed By':'*Filed By/ Petitioner(s)'}}</label>
      <div class="flex">
        <mat-form-field appearance="outline" class="flex-grow mr-2">
          <input matInput  [value]="data.data[0].partiesByPrtIdReallyIssuedBy" readonly [disabled]="true" />
        </mat-form-field> 
        <mat-form-field appearance="outline" class="flex-grow">
          <input matInput  [value]="data.data[0].partiesByPrtIdReallyIssuedByName" required placeholder="party name" readonly [disabled]="true" [tabindex]="null"/>
          <button mat-icon-button matSuffix  *ngIf="!isEditMode">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <button mat-icon-button color="primary" class="ml-1"   *ngIf="!isEditMode">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <div class="col-1"></div>
    <div class="col-4" *ngIf="!isSupreme && !isCOA && data.data[0].caseCategory!=='FI'">
      <label class="required-label">Filed on</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width">
        <input  matInput
        [value]="data.data[0].dateReceived"
        readonly 
        [disabled]="true" [tabindex]="null"/>
      </mat-form-field>
      </div>
    </div>
    <div class="col-4" *ngIf="data.data[0].caseCategory==='FI'">
      <label class="required-label" >Case Stage</label>
      <div class="flex">  
      <mat-form-field appearance="outline" class="full-width" >
        <input matInput   readonly [value]="data.data[0].cptShortName" [disabled]="true" [tabindex]="null"/>
      </mat-form-field>
      </div>
    </div>
    <div class="col-4" *ngIf="data.data[0].caseCategory!=='FI'&&(isSupreme ||!isCOA)&&(isSupreme ||isCOA)">
      <label class="required-label" >Old Appeal Number</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width" >
        <input matInput readonly [value]="data.data[0].oldCaseNumber" [disabled]="true" [tabindex]="null" />
      </mat-form-field>
      </div>
    </div>
    
    <!-- Table   Section -->

  </div>

  <!-- Row 3: Plaintiff(s)/Claimant(s) -->
  <div class="flex flex-wrap ">
    <div class="col-7">
      <label class="required-label">{{receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA ?'*Appellant(s)':'*Plaintiff(s)/ Claimant(s)'}}</label>
      <div class="flex">
        <mat-form-field appearance="outline" class="flex-grow mr-2">  
          <input matInput [value]="data.data[0].partiesByPrtIdIssuedBy" readonly [disabled]="true" [tabindex]="null" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-grow"  >
          <input matInput  [value]="data.data[0].partiesByPrtIdIssuedByName" required placeholder="party name" readonly [disabled]="true" [tabindex]="null"/>
          <button mat-icon-button matSuffix  *ngIf="!isEditMode">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <button mat-icon-button color="primary" class="ml-1"  *ngIf="!isEditMode" >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div class="col-1"  ></div>
    <div class="col-4" *ngIf="data.data[0].caseCategory!=='FI'&& (isSupreme||isCOA)">
      <label class="required-label" >{{ isSupreme ? 'Trial Court Number' : 'Suit Number' }}</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width" >
        <input matInput readonly [value]="data.data[0].suitNumber" [disabled]="true" [tabindex]="null"/>
      </mat-form-field>
      </div>
    </div>
    <div class="col-4" *ngIf="data.data[0].caseCategory==='FI'">
      <label class="required-label">Filed on</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width">
        <input  matInput
        [value]="data.data[0].dateReceived"
        readonly 
        [disabled]="true" [tabindex]="null"/>
      </mat-form-field>
      </div>
    </div>
    
    <div class="col-4" *ngIf="data.data[0].caseCategory!=='FI'&&!isSupreme && !isCOA">
      <label class="required-label" >Old Appeal Number</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width" >
        <input matInput readonly [value]="data.data[0].oldCaseNumber" [disabled]="true" [tabindex]="null"/>
      </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Row 4: Defendant(s) -->
  <div class="flex flex-wrap">
    <div class="col-7">
      <label class="required-label">{{receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA ?'*Respondent(s)':'*Defendant(s)'}}</label>
      <div class="flex">
        <mat-form-field appearance="outline" class="flex-grow mr-2">
          <input matInput  [value]="data.data[0].partyIdCharging" readonly [disabled]="true" [tabindex]="null" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-grow">
          <input matInput   [value]="data.data[0].partyIdChargingName"required placeholder="party name" readonly  [disabled]="true" [tabindex]="null"/>
          <button mat-icon-button matSuffix  *ngIf="!isEditMode">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <button mat-icon-button color="primary" class="ml-1"   *ngIf="!isEditMode">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div class="col-1"></div>
    <div class="col-4">
      <label class="required-label">Number of copies</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput type="number" formControlName="selectedCopies" [min]="1" value="data.data[0].numberOfCopies" 
          />
      </mat-form-field>
    </div>
  </div>

  <!-- Row 5: Comments -->
  <div class="flex flex-wrap ">
    <div class="col-12">
      <mat-label>Comments</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <textarea matInput formControlName="comments" placeholder="Enter comments" rows="2" cols="100"
          style="resize: vertical; min-height: 50px;" value="data.data[0].comments" tabindex="0"></textarea>
      </mat-form-field>
    </div></div>
  </div>
  <div class="col-4 px-2">
    <div class="form-container-sub">
      <h3>Auto Generated</h3>
      <div class="form-group">
        <label for="caseNumber">{{ receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA? 'Appeal Number:' : 'Case Number:' }}</label>
        <input id="caseNumber" type="text" class="form-control" [value]="data.data[0].courtCaseNumber" readonly [tabindex]="null" [disabled]="true"/>
      </div>
      <div class="form-group">
        <label for="casePhaseId">{{ receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA? 'Appeal Phase ID:' : 'Case Phase ID:' }}</label>
        <input id="casePhaseId" type="text" class="form-control" [value]="data.data[0].casePhaseId" readonly [tabindex]="null"  [disabled]="true"/>
      </div>
      <div class="form-group">
        <label for="documentId">Document ID:</label>
        <input id="documentId" type="text" class="form-control" [value]="data.data[0].docId" readonly [tabindex]="null" [disabled]="true" />
      </div>
      <div class="form-group">
        <label for="caseId">{{ receivedCaseData()[0].caseCategory!=='FI'||isSupreme||isCOA? 'Appeal ID:' : 'Case ID:' }}    </label>
        <input id="caseId" type="text" class="form-control" [value]="data.data[0].casePhaseCasId" readonly [tabindex]="null" [disabled]="true" />
      </div></div></div></div>
       <mat-accordion *ngIf="isSupreme" class="w-full px-2">
          <mat-expansion-panel [ngStyle]="{'background-color': '#f5f9f7'}">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Additional Details
            </mat-panel-title>
          </mat-expansion-panel-header>


    <app-court-form 
      [courtOfAppealForm]="courtOfAppealForm"
      [trialCourtForm]="trialCourtForm"
      [isAddReadonly]="false"
      [initialData]="{
      lowerDivision: searchForm2.get('lowerCourt')?.value,
      lowerCourtCaseNo: searchForm2.get('oldSuitNumber')?.value
    }"
    ></app-court-form>
  </mat-expansion-panel>
</mat-accordion>
  <!-- Row 6: Action Buttons -->
  <div class="flex flex-wrap justify-content-between">
    <div class="col-12 text-center">
      <!-- <div class = "col-span-4 flex justify-center gap-4 mt-4"> -->
      <button type="button" mat-flat-button class="cancel-button mr-2" (click)="close()">Cancel</button>
      <button type="submit" mat-flat-button color="primary" (click)="save()">Save</button>
    </div>
  </div>
</form>
 
</div>